export interface ApplicationMessageHandlerData {
    key: string;
    id: string;
    type: string;
    data: any; // Would be good to properly type guard this in the future
}

export abstract class ApplicationCommunicator {
    constructor(
        protected url: string,
        protected handleMessage: (data: ApplicationMessageHandlerData) => void,
        protected getName: () => string
    ) {}

    /**
     * Setup and create the communication channel
     */
    public abstract create(): Promise<void>;

    /**
     * Remove the communication channel with the application
     */
    public abstract destroy(): Promise<void>;

    /**
     * Update the communication channel with new information from a sync
     */
    public abstract update(url: string): Promise<void>;

    /**
     * Send a message to the application we're communicating with, returns true on success, false otherwise
     */
    public abstract sendMessage(type: string, data: unknown, id?: string): boolean;

    /**
     * Check if the communicator is ready for communication
     */
    public abstract isReady(): boolean;

    /**
     * Get the raw URL that will be loaded, this is without any additional parameters added
     */
    public abstract getRawUrl(): URL | string;

    /**
     * Get the fully resolved URL that has been loaded by the communicator
     */
    public abstract getLoadedUrl(): URL | string;

    /**
     * Determine whether a message is from the current source (used for external page communication)
     */
    public abstract isEventFromSource(event: MessageEvent): boolean;
}
